export type ChartHistoryFilterType = "all" | "1M" | "1W" | "1D";

export const CHART_HEIGHT = 160;

export const SAMPLING_INTERVAL_MINUTES: Record<ChartHistoryFilterType, number> = {
  all: 720, // half day (12 * 60)
  "1M": 180, // 3 hours (3 * 60)
  "1W": 30, // 30 minutes
  "1D": 5, // 5 minutes
};

export const YES_NO_COLORS = [
  "#00AFCE", // Yes
  "#FF7FD2", // No
];

export const MULTIPLE_COLORS = [
  "#4879FF",
  "#00CE97",
  "#FF7C48",
  "#E88EFF",
  "#00AAFF",
  "#C0C000",
  "#FF9C25",
  "#FF7DC6",
  "#00D2DD",
  "#8ECF00",
  "#FF6469",
  "#AA9BFF",
  "#86AFD3",
  "#B5BD8A",
  "#ECC100",
  "#CAA396",
  "#819CFF",
  "#8BBE8B",
  "#ABABAB",
  "#6EC2AD",
  "#5A85FF",
  "#1CD1A3",
  "#FF8A5A",
  "#EB9CFF",
  "#1AB5FF",
  "#CACC10",
  "#FFA638",
  "#FF8DD0",
  "#10D8E5",
  "#9DD410",
  "#FF7679",
  "#B5A7FF",
  "#93B6DB",
  "#BFC598",
  "#F0CA10",
  "#D3ACA1",
  "#8DA7FF",
  "#97C697",
  "#B5B5B5",
  "#7ECAB5",
  "#5F91FF",
  "#2DD4AF",
  "#FF976C",
  "#EEA9FF",
  "#2DC0FF",
  "#D3D520",
  "#FFB04B",
  "#FF9BDA",
  "#20DEED",
  "#ABDA20",
  "#FF8689",
  "#C0B2FF",
  "#A0BFE3",
  "#C9CD9F",
  "#F4D120",
  "#DCB7AC",
  "#99B3FF",
  "#A3D1A3",
  "#C0C0C0",
  "#8DD2BD",
  "#6B9DFF",
  "#40D7BB",
  "#FFA47E",
  "#F1B6FF",
  "#40CBFF",
  "#DDDE30",
  "#FFBA5E",
  "#FFA9E4",
  "#30E4F5",
  "#BADE30",
  "#FF96A0",
  "#CBB5FF",
  "#ADC8EB",
  "#D3D5B5",
  "#F8D830",
  "#E5C2B7",
  "#A5BFFF",
  "#AFDAAF",
  "#CACACA",
  "#9EDAC5",
  "#779DFF",
  "#53DABC",
  "#FFB190",
  "#F4C3FF",
  "#53D6FF",
  "#E6E740",
  "#FFC471",
  "#FFB7EE",
  "#40EAFD",
  "#C9E240",
  "#FFA6B7",
  "#D6C8FF",
  "#BAD1F3",
  "#DDDDC6",
  "#FBE040",
  "#EED0C2",
  "#B1CBFF",
  "#BBE3BB",
  "#D4D4D4",
  "#AEE2CD",
  "#83AFFF",
  "#66DDC7",
  "#FFBEA2",
];

export const BACKGROUND_MULTIPLE_COLORS = [
  "#4879FF20",
  "#00CE9720",
  "#FF7C4820",
  "#E88EFF20",
  "#00AAFF20",
  "#C0C00020",
  "#FF9C2520",
  "#FF7DC620",
  "#00D2DD20",
  "#8ECF0020",
  "#FF646920",
  "#AA9BFF20",
  "#86AFD320",
  "#B5BD8A20",
  "#ECC10020",
  "#CAA39620",
  "#819CFF20",
  "#8BBE8B20",
  "#ABABAB20",
  "#6EC2AD20",
  "#5A85FF20",
  "#1CD1A320",
  "#FF8A5A20",
  "#EB9CFF20",
  "#1AB5FF20",
  "#CACC1020",
  "#FFA63820",
  "#FF8DD020",
  "#10D8E520",
  "#9DD41020",
  "#FF767920",
  "#B5A7FF20",
  "#93B6DB20",
  "#BFC59820",
  "#F0CA1020",
  "#D3ACA120",
  "#8DA7FF20",
  "#97C69720",
  "#B5B5B520",
  "#7ECAB520",
  "#5F91FF20",
  "#2DD4AF20",
  "#FF976C20",
  "#EEA9FF20",
  "#2DC0FF20",
  "#D3D52020",
  "#FFB04B20",
  "#FF9BDA20",
  "#20DEED20",
  "#ABDA2020",
  "#FF868920",
  "#C0B2FF20",
  "#A0BFE320",
  "#C9CD9F20",
  "#F4D12020",
  "#DCB7AC20",
  "#99B3FF20",
  "#A3D1A320",
  "#C0C0C020",
  "#8DD2BD20",
  "#6B9DFF20",
  "#40D7BB20",
  "#FFA47E20",
  "#F1B6FF20",
  "#40CBFF20",
  "#DDDE3020",
  "#FFBA5E20",
  "#FFA9E420",
  "#30E4F520",
  "#BADE3020",
  "#FF96A020",
  "#CBB5FF20",
  "#ADC8EB20",
  "#D3D5B520",
  "#F8D83020",
  "#E5C2B720",
  "#A5BFFF20",
  "#AFDAAF20",
  "#CACACA20",
  "#9EDAC520",
  "#779DFF20",
  "#53DABC20",
  "#FFB19020",
  "#F4C3FF20",
  "#53D6FF20",
  "#E6E74020",
  "#FFC47120",
  "#FFB7EE20",
  "#40EAFD20",
  "#C9E24020",
  "#FFA6B720",
  "#D6C8FF20",
  "#BAD1F320",
  "#DDDDC620",
  "#FBE04020",
  "#EED0C220",
  "#B1CBFF20",
  "#BBE3BB20",
  "#D4D4D420",
  "#AEE2CD20",
  "#83AFFF20",
  "#66DDC720",
  "#FFBEA220",
];
